// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__moAD_","unreadBadge":"styles_unreadBadge__2aLWi","modalContent":"styles_modalContent__5djGl","modal":"styles_modal__1pip0"};